module.exports = __webpack_public_path__ + "img/43__535-220-low.c14035aa.jpg";